/**
 * The type of redux actions that can be performed
 * @readonly
 * @enum {string}
 */
export const ACTION_TYPE = {
	//Modal Popup
	OPEN_MODAL_POPUP: 'OPEN_MODAL_POPUP',
	CLOSE_MODAL_POPUP: 'CLOSE_MODAL_POPUP',
	//Login
	LOGIN_REQUEST: 'LOGIN_REQUEST',
	LOGIN_RESPONSE: 'LOGIN_RESPONSE',
	LOGIN_RESPONSE_FAIL: 'LOGIN_RESPONSE_FAIL',
	REFRESH_REQUEST: 'REFRESH_REQUEST',
	REFRESH_RESPONSE: 'REFRESH_RESPONSE',
	REFRESH_RESPONSE_FAIL: 'REFRESH_RESPONSE_FAIL',
	//Logout
	LOGOUT: 'LOGOUT',
	//SignUp
	SIGNUP_REQUEST: 'SIGNUP_REQUEST',
	SIGNUP_RESPONSE: 'SIGNUP_RESPONSE',
	SIGNUP_RESPONSE_FAIL: 'SIGNUP_RESPONSE_FAIL',
	//Confirm SignUp
	CONFIRM_SIGNUP_REQUEST: 'CONFIRM_SIGNUP_REQUEST',
	CONFIRM_SIGNUP_RESPONSE: 'CONFIRM_SIGNUP_RESPONSE',
	CONFIRM_SIGNUP_RESPONSE_FAIL: 'CONFIRM_SIGNUP_RESPONSE_FAIL',
	//Resend Confirmation Code
	RESEND_CONFIRMATION_REQUEST: 'RESEND_CONFIRMATION_REQUEST',
	RESEND_CONFIRMATION_RESPONSE: 'RESEND_CONFIRMATION_RESPONSE',
	RESEND_CONFIRMATION_RESPONSE_FAIL: 'RESEND_CONFIRMATION_RESPONSE_FAIL',
	//AddDomain
	ADD_DOMAIN_REQUEST: 'ADD_DOMAIN_REQUEST',
	ADD_DOMAIN_RESPONSE: 'ADD_DOMAIN_RESPONSE',
	ADD_DOMAIN_RESPONSE_FAIL: 'ADD_DOMAIN_RESPONSE_FAIL',
	//AddDomainResource
	ADD_DOMAIN_RESOURCE_REQUEST: 'ADD_DOMAIN_RESOURCE_REQUEST',
	ADD_DOMAIN_RESOURCE_RESPONSE: 'ADD_DOMAIN_RESOURCE_RESPONSE',
	ADD_DOMAIN_RESOURCE_RESPONSE_FAIL: 'ADD_DOMAIN_RESOURCE_RESPONSE_FAIL',
	//DeleteDomainResource
	DEL_DOMAIN_RESOURCE_REQUEST: 'DEL_DOMAIN_RESOURCE_REQUEST',
	DEL_DOMAIN_RESOURCE_RESPONSE: 'DEL_DOMAIN_RESOURCE_RESPONSE',
	DEL_DOMAIN_RESOURCE_RESPONSE_FAIL: 'DEL_DOMAIN_RESOURCE_RESPONSE_FAIL',
  //EditDomain
  EDIT_DOMAIN_TOGGLE: 'TOGGLE_DOMAIN_EDIT',
	//Login Form / Sign Up Form
	USERNAME_CHANGED: 'USERNAME_CHANGED',
	PASSWORD_CHANGED: 'PASSWORD_CHANGED',
	//Sign Up Form
	EMAIL_CHANGED: 'EMAIL_CHANGED',
	//Confirmation Form
	CONFIRMATION_CODE_CHANGED: 'CONFIRMATION_CODE_CHANGED',
	//AddDomain Form
	DOMAIN_CHANGED: 'DOMAIN_CHANGED',
	//AddDomainResource Form
	RESOURCE_URL_CHANGED: 'RESOURCE_URL_CHANGED',
	//Get Resources 
	GET_RESOURCES_REQUEST: 'GET_RESOURCES_REQUEST',
	GET_RESOURCES_RESPONSE: 'GET_RESOURCES_RESPONSE',
	GET_RESOURCES_RESPONSE_FAIL: 'GET_RESOURCES_RESPONSE_FAIL',
  //Account Management
  PAYMENT_METHOD_CHANGED: 'PAYMENT_METHOD_CHANGED',
  GET_PAYMENT_TOKEN_REQUEST: 'GET_PAYMENT_TOKEN_REQUEST',
  GET_PAYMENT_TOKEN_RESPONSE: 'GET_PAYMENT_TOKEN_RESPONSE',
  GET_PAYMENT_TOKEN_RESPONSE_FAIL: 'GET_PAYMENT_TOKEN_RESPONSE_FAIL',
  ADD_PAYMENT_METHOD_REQUEST: 'ADD_PAYMENT_METHOD_REQUEST',
  ADD_PAYMENT_METHOD_RESPONSE: 'ADD_PAYMENT_METHOD_RESPONSE',
  ADD_PAYMENT_METHOD_RESPONSE_FAIL: 'ADD_PAYMENT_METHOD_RESPONSE_FAIL',
};



// WEBPACK FOOTER //
// ./src/redux/types.js